'use client';

import {
  type IListPublicCollectionChallengesBySlugV2Item,
  listPublicCollectionChallengesBySlugV2Api,
} from '@repo/sdk';
import { useState, useTransition } from 'react';
import { ChallengeCard } from './challenge-card';

interface ILoadMoreChallengesProps {
  slug: string;
  initialNextCursor: string | null;
}

export function LoadMoreChallenges({
  slug,
  initialNextCursor,
}: ILoadMoreChallengesProps): React.JSX.Element | null {
  const [cursor, setCursor] = useState<string | null>(initialNextCursor);
  const [items, setItems] = useState<IListPublicCollectionChallengesBySlugV2Item[]>([]);
  const [pending, start] = useTransition();

  if (cursor === null && items.length === 0) {
    return null;
  }

  return (
    <>
      {items.length > 0 && (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((ch) => (
            <ChallengeCard
              key={ch.id}
              slug={ch.slug}
              title={ch.title}
              cefrLevel={ch.cefrLevel}
              definition={ch.definition}
              videoCount={ch.videoCount}
            />
          ))}
        </div>
      )}
      {cursor !== null && (
        <button
          type="button"
          disabled={pending}
          onClick={() =>
            start(async () => {
              const res = await listPublicCollectionChallengesBySlugV2Api(slug, cursor);
              const data = res.data?.data ?? [];
              setItems((prev) => [...prev, ...data]);
              setCursor(res.data?.pagination?.nextCursor ?? null);
            })
          }
          className="mt-6 w-full rounded-full border border-border bg-card px-5 py-2.5 text-sm font-medium text-foreground hover:bg-muted disabled:opacity-60"
        >
          {pending ? 'Loading…' : 'Load more'}
        </button>
      )}
    </>
  );
}
